import React from 'react';

const Video = ({ className, file, poster, transcription }) => {
  return (
    <div className={className}>
      <div className="paragraph--type--windmill-data__media">
        <video muted="muted" autoPlay loop preload poster={poster}>
          <source src={file} type="video/mp4" />
          <track label="Dutch description" kind="captions" srcLang="nl" src={transcription} default />
        </video>
      </div>
    </div>
  );
};

export default Video;
